import { MapPin, CalendarDays, Clock } from "lucide-react";
import { TRAILER_SCHEDULE } from "../lib/trailerSchedule";

const TrailerSchedule = () => {
  const data = TRAILER_SCHEDULE;
  if (!data?.active || !data.stops?.length) return null;

  return (
    <section data-testid="trailer-schedule" className="max-w-7xl mx-auto px-6 lg:px-10 pt-4 pb-8">
      <div className="relative rounded-3xl overflow-hidden border border-[#00b4ff]/40 bg-gradient-to-br from-[#0a0a10] via-[#0a0a10] to-[#051018] shadow-[0_0_30px_rgba(0,180,255,0.15)]">
        <div className="h-[2px] bg-gradient-to-r from-[#00b4ff] via-[#ff1a8c] to-[#00b4ff]" />
        <div className="p-6 sm:p-8">
          <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1 mb-1">
            <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full border border-[#00b4ff]/60 text-[9px] uppercase tracking-[0.28em] text-[#00b4ff]">
              <CalendarDays className="w-2.5 h-2.5" /> This week
            </span>
          </div>
          <h2 className="font-script text-4xl sm:text-5xl neon-gradient-text leading-[1] mb-2">
            Where's the trailer this week?
          </h2>
          {data.note && (
            <p data-testid="trailer-schedule-note" className="text-sm text-gray-400 mb-6 max-w-2xl">{data.note}</p>
          )}

          <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mt-4">
            {data.stops.map((stop) => (
              <li
                key={`${stop.day}-${stop.name}`}
                data-testid={`trailer-stop-${stop.day.toLowerCase()}`}
                className="rounded-2xl border border-white/10 bg-black/40 p-5 hover:border-[#ff1a8c]/60 hover:shadow-[0_0_22px_rgba(255,26,140,0.2)] transition-all"
              >
                <p className="text-[10px] uppercase tracking-[0.28em] text-[#ff1a8c] font-semibold mb-2">{stop.day}</p>
                <p className="text-white font-semibold leading-snug mb-2">{stop.name}</p>
                <p className="flex items-start gap-1.5 text-xs text-gray-400">
                  <MapPin className="w-3.5 h-3.5 text-[#00b4ff] shrink-0 mt-[1px]" /> {stop.location}
                </p>
                {stop.time && (
                  <p className="flex items-center gap-1.5 text-xs text-gray-400 mt-1.5">
                    <Clock className="w-3.5 h-3.5 text-[#00b4ff] shrink-0" /> {stop.time}
                  </p>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default TrailerSchedule;
